(function () {
  let bcvRate = null;

  async function fetchBCVRate() {
    // API 1: sin restricciones CORS
    try {
      const res = await fetch('https://cdn.jsdelivr.net/gh/fjmn2001/pyDolarVenezuela@main/data/data.json');
      if (res.ok) {
        const data = await res.json();
        if (data && data.bcv) {
          bcvRate = parseFloat(data.bcv.price || data.bcv);
        }
      }
    } catch (e) {}

    // API 2: respaldo
    if (!bcvRate) {
      try {
        const res = await fetch('https://api.allorigins.win/raw?url=' + encodeURIComponent('https://pydolarvenezuela-api.vercel.app/api/v1/dollar?page=bcv'));
        if (res.ok) {
          const data = await res.json();
          if (data && data.price) bcvRate = parseFloat(data.price);
        }
      } catch (e) {}
    }

    // API 3: open exchange rates
    if (!bcvRate) {
      try {
        const res = await fetch('https://open.er-api.com/v6/latest/USD');
        if (res.ok) {
          const data = await res.json();
          if (data && data.rates && data.rates.VES) bcvRate = parseFloat(data.rates.VES);
        }
      } catch (e) {}
    }

    if (bcvRate && bcvRate > 0) {
      updatePrices();
    } else {
      // Tasa de respaldo - ACTUALIZAR manualmente
      bcvRate = 1000;
      updatePrices();
    }
  }

  function formatBs(amount) {
    return 'Bs. ' + amount.toLocaleString('es-VE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  function extractUSDPrice(el) {
    const clone = el.cloneNode(true);
    clone.querySelectorAll('.visually-hidden, .bcv-price, [aria-hidden="true"], .unit-price').forEach(s => s.remove());
    const text = clone.textContent.trim();
    const match = text.match(/[\d,]+\.?\d*/);
    if (!match) return null;
    return parseFloat(match[0].replace(/,/g, ''));
  }

  function updatePrices() {
    if (!bcvRate) return;

    const selectors = [
      'span.price:not(.compare-at-price)',
      '.price-item__group.price:not(.compare-at-price)',
      'product-price .price:not(.compare-at-price)',
      '[ref="priceContainer"] > .price:not(.compare-at-price)',
      '.price-item--regular:not(.compare-at-price)'
    ];

    let priceElements = [];
    selectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(el => {
        if (!priceElements.includes(el)) priceElements.push(el);
      });
    });

    priceElements.forEach((el) => {
      if (el.dataset.bcvDone) return;
      if (el.querySelector('.bcv-price')) return;
      if (el.closest('.compare-at-price')) return;
      const usdPrice = extractUSDPrice(el);
      if (usdPrice && usdPrice > 0) {
        const bsPrice = usdPrice * bcvRate;
       // Guardar texto USD original
const usdText = extractUSDPrice(el);
const usdFormatted = '$' + usdText.toFixed(2) + ' USD';

// Bs ARRIBA - precio principal
const bsLabel = document.createElement('span');
bsLabel.className = 'bcv-price';
bsLabel.style.cssText = 'display:block;font-size:1.1em;color:#222;font-weight:700;line-height:1.3;';
bsLabel.textContent = formatBs(bsPrice);

// USD ABAJO - precio secundario
const usdLabel = document.createElement('span');
usdLabel.className = 'bcv-usd-price';
usdLabel.style.cssText = 'display:block;font-size:0.78em;color:#888;font-weight:400;margin-top:2px;line-height:1.3;';
usdLabel.textContent = usdFormatted;

// Reemplazar contenido: Bs primero, USD después
el.innerHTML = '';
el.appendChild(bsLabel);
el.appendChild(usdLabel);
el.dataset.bcvDone = 'true';

      }
    });
  }

  function init() {
    fetchBCVRate();
    setTimeout(() => { if (bcvRate) updatePrices(); }, 2000);
    setTimeout(() => { if (bcvRate) updatePrices(); }, 5000);
    setTimeout(() => { if (bcvRate) updatePrices(); }, 10000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', () => { if (bcvRate) updatePrices(); });

  let observerTimer;
  const observer = new MutationObserver(() => {
    if (!bcvRate) return;
    clearTimeout(observerTimer);
    observerTimer = setTimeout(updatePrices, 500);
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
